<template>
  <div id="app2">
    <router-view />
  </div>
</template>

<script lang="javascript">
import { mapState, mapMutations, mapGetters } from 'vuex'
export default { 
  created() {
      console.log('------------------初始化阶段 App s------------------')
      this.initStore()
      console.log('------------------初始化阶段 App e------------------')
  },
  computed: {
        ...mapState(['userInfo'])
    },
  methods: {
        ...mapMutations(['initStore']),
        checkLogin(cb) {
            if (!this.isLogined()) {
                return
            }
            cb()
        },
        isLogined() {
            return this.userInfo.token.length > 0
        },
  }
}

</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,body,#app2{
  width: 100%;
  // height: 100%;
  background-color: #fff;
  max-width: 750px;
  margin: 0 auto;
}
#app2 {
}
</style>
